import TobbszorosKerdesDto from 'app/admin/tobbszoroskerdes/dto/TobbszorosKerdesDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class TobbszorosKerdesTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'tobbszorosKerdesTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, TobbszorosKerdesDto)))
				.catch(reject);
		});
	}
}

export default new TobbszorosKerdesTableService();
